import Container from 'react-bootstrap/Container'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import { Link, useNavigate } from 'react-router-dom'
import { useLogout } from '../../hooks/useLogout'

const SuppProfileHeader = () => {
  const navigate = useNavigate()
  const { logout } = useLogout()

  return (
    <>
      {/* <Navbar className='my-nav' variant='light' expand='lg'> */}
      <Navbar className='my-nav' expand='lg'>
        <Container>
          <Navbar.Toggle aria-controls='supp-header' />
          <Navbar.Collapse id='supp-header'>
            <Nav
              defaultActiveKey={'SupplierProfile'}
              //   onSelect={(selectedKey) => alert(`selected ${selectedKey}`)}
            >
              <Nav.Link
                onClick={() => navigate('/business')}
                eventKey={'SupplierProfile'}
                className='my-link'
              >
                Dashboard
              </Nav.Link>
              <Nav.Link className='my-link' eventKey='MyOrders'>
                My orders
              </Nav.Link>
              <Nav.Link className='my-link' eventKey='MyServices'>
                My services
              </Nav.Link>{' '}
              <Nav.Link
                className='my-link'
                as={Link}
                to='/business/companydetails'
              >
                Business Details
              </Nav.Link>{' '}
              <Nav.Link
                className='my-link'
                as={Link}
                to='/business/personaldetails'
              >
                personal settings
              </Nav.Link>{' '}
              <Nav.Link style={{ paddingRight: '30px' }} as={Link} to='/'>
                Home
              </Nav.Link>{' '}
              <Nav.Link
                style={{ paddingRight: '30px' }}
                onClick={() => logout()}
              >
                Logout
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <br />
      <br />
      <br />
      <br />
      <br />
    </>
  )
}

export default SuppProfileHeader
